/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import Input from "../../../component/input";
import Loader from "../../../component/loader";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Select from "../../../component/select";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import classes from "./updateOrderContact.module.css";
import Grid from "@mui/material/Grid";
import InputPhone from "../../../component/inputPhone";
import Button from "../../../component/button";
import stateCode from "../../../helper/stateCode";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import validator from "../../../helper/validator";
import { withNavigation } from "../../../helper/withNavigation";

// Update order contact page (parent View order summary)
class UpdateOrderContact extends Component {
  // Declare property values that belongs to the component
  state = {
    orderId: "",
    loading: true,
    details: null,
    isSame: false,
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    // Remove error message on component load
    this.props.setCompDidMount();
    // Get order id from URL params
    this.setState({
      orderId: this.props.router.params.orderId,
    });
    // Fetch order contact detail
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/orders/${this.props.router.params.orderId}/contacts`,
    )
      .then((res) => {
        this.setState({
          details: res.data.customer,
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({ loading: false });
      });
  }

  // Change basic contact details
  setDetails = (e) => {
    let details = { ...this.state.details };
    details[e.target.name] = e.target.value;
    this.setState({
      details: details,
    });
  };

  // Change billing address
  setBilling = (e) => {
    let details = { ...this.state.details };
    details.billing[e.target.name] = e.target.value;
    this.setState({
      details: details,
    });
  };

  // Change shipping address
  setShipping = (e) => {
    let details = { ...this.state.details };
    details.shipping[e.target.name] = e.target.value;
    this.setState({
      details: details,
    });
  };

  // Craete days list and return
  daysArray = () => {
    let days = [];
    for (let i = 2; i < 32; i++) {
      days.push("" + i);
    }
    return days;
  };

  // Close error message
  closeErrorMessage = () => {
    this.props.setErrorMessage("", false);
  };

  // Set shipping adress same as billing billing
  setIsSame = () => {
    this.setState({
      isSame: !this.state.isSame,
    });
  };

  // This function is used to vallidate phone number
  validatePhoneNo = (val) => {
    if (val) {
      var pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      return pattern.test(val);
    }
    return true;
  };

  // Validate basic form info
  validateForm = () => {
    for (let key in this.state.details) {
      if (
        key == "email" ||
        key == "firstName" ||
        key == "lastName" ||
        key == "officePhone"
      ) {
        if (!this.state.details[key]) {
          return false;
        }
      }
    }
    return true;
  };

  // Validate billing and shipping address
  validateAddress = (data) => {
    for (let key in data) {
      if (
        key == "attention" ||
        key == "city" ||
        key == "country" ||
        key == "state" ||
        key == "street1" ||
        key == "zip"
      ) {
        if (!data[key]) {
          return false;
        }
      }
    }
    return true;
  };

  // Validate form before submit
  update = () => {
    this.setState({ loading: true });
    // Validate office phone number
    if (!this.validatePhoneNo(this.state.details.officePhone)) {
      this.props.setErrorMessage("Office phone number is not valid.", false);
      this.setState({ loading: false });
    }
    // Validate mobile phone number
    else if (!this.validatePhoneNo(this.state.details.mobilePhone)) {
      this.props.setErrorMessage("Mobile phone number is not valid.", false);
      this.setState({ loading: false });
    }
    // Validate billing phone number
    else if (!this.validatePhoneNo(this.state.details.billing.phone)) {
      this.props.setErrorMessage("Billing phone number is not valid.", false);
      this.setState({ loading: false });
    }
    // Validate shipping phone number
    else if (
      !this.state.isSame &&
      !this.validatePhoneNo(this.state.details.shipping.phone)
    ) {
      this.props.setErrorMessage("Shipping phone number is not valid.", false);
      this.setState({ loading: false });
    }
    // Validate basic detail mandatory fields
    else if (!this.validateForm()) {
      this.props.setErrorMessage(
        "All Fields marked with * are mandatory.",
        false,
      );
      this.setState({ loading: false });
    }
    // Validate email id
    else if (!validator.Email(this.state.details.email)) {
      this.props.setErrorMessage("Contact email is invalid", false);
      this.setState({ loading: false });
    }
    // Validate mandatory billing address fields
    else if (!this.validateAddress(this.state.details.billing)) {
      this.props.setErrorMessage(
        "All Fields marked with * are mandatory.",
        false,
      );
      this.setState({ loading: false });
    } else if (!this.state.isSame) {
      // Validate mandatory shipping address fields
      if (!this.validateAddress(this.state.details.shipping)) {
        this.props.setErrorMessage(
          "All Fields marked with * are mandatory.",
          false,
        );
        this.setState({ loading: false });
      } else {
        // Submit form if valid
        this.submitForm();
      }
    } else {
      // Submit form if valid
      this.submitForm();
    }
  };

  // Create data and update order contact
  submitForm = () => {
    let details = { ...this.state.details };
    let data = {};
    // Set basic contact details
    data.contact = {
      firstName: details.firstName,
      lastName: details.lastName,
      mobilePhoneMechId: details.mobilePhoneMechId,
      mobilePhone: details.mobilePhone,
      officePhone: details.officePhone,
      officePhoneMechId: details.officePhoneMechId,
      emailMechId: details.emailMechId,
      email: details.email,
      partyId: details.partyId,
    };
    // Set billing address
    data.billing = { ...details.billing };

    // Set shipping address
    if (this.state.isSame) {
      data.shipping = { ...details.billing };
      data.shipping.phoneMechId = details.shipping.phoneMechId;
      data.shipping.postalMechId = details.shipping.postalMechId;
    } else {
      data.shipping = { ...details.shipping };
    }

    BusApiCall(
      "PUT",
      `${constants.busInternalUrl}/orders/${this.state.orderId}/contacts`,
      data,
    )
      .then((res) => {
        this.props.updateInfo();
        this.setState({ loading: false });
        this.props.router.navigate(`/order/${this.state.orderId}`);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <main>
        {this.state.details && (
          <>
            <h2 className={classes.checkoutTitle}>
              Business Account #{this.state.details.ban}
            </h2>
            <React.Fragment>
              <Grid container spacing={1}>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    inputClass={classes.inputClassDisabled}
                    name={"accountName"}
                    placeholder={"Account Name"}
                    label={"Account Name"}
                    value={this.state.details.accountName}
                    disabled={true}
                    onChange={(e) => {
                      this.setDetails(e);
                      this.closeErrorMessage();
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <h3 className={classes.DetailssubTitle}>Contact details</h3>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    inputClass={classes.inputClassDisabled}
                    name={"firstName"}
                    placeholder={"First Name"}
                    label={"First Name *"}
                    value={this.state.details.firstName}
                    disabled={true}
                    onChange={(e) => {
                      this.setDetails(e);
                      this.closeErrorMessage();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    inputClass={classes.inputClassDisabled}
                    name={"lastName"}
                    placeholder={"Last Name"}
                    label={"Last Name *"}
                    value={this.state.details.lastName}
                    disabled={true}
                    onChange={(e) => {
                      this.setDetails(e);
                      this.closeErrorMessage();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <InputPhone
                    inputClass={classes.inputClass}
                    name={"officePhone"}
                    placeholder={"Office Phone"}
                    label={"Office Phone *"}
                    value={this.state.details.officePhone}
                    onChange={(e) => {
                      this.setDetails(e);
                      this.closeErrorMessage();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <InputPhone
                    inputClass={classes.inputClass}
                    name={"mobilePhone"}
                    placeholder={"Mobile Phone"}
                    label={"Mobile Phone"}
                    value={this.state.details.mobilePhone}
                    onChange={(e) => {
                      this.setDetails(e);
                      this.closeErrorMessage();
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    inputClass={classes.inputClass}
                    name={"email"}
                    placeholder={"Email"}
                    label={"Email *"}
                    value={this.state.details.email}
                    onChange={(e) => {
                      this.setDetails(e);
                      this.closeErrorMessage();
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <h3
                  className={classes.DetailssubTitle}
                  style={{ paddingTop: "15px" }}
                >
                  Billing Address
                </h3>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    inputClass={classes.inputClass}
                    name={"attention"}
                    placeholder={"Attention"}
                    label={"Attention *"}
                    value={this.state.details.billing.attention}
                    onChange={(e) => {
                      this.setBilling(e);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <InputPhone
                    inputClass={classes.inputClass}
                    name={"phone"}
                    placeholder={"Phone"}
                    label={"Phone"}
                    value={this.state.details.billing.phone}
                    onChange={(e) => {
                      this.setBilling(e);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    inputClass={classes.inputClass}
                    name={"street1"}
                    placeholder={"Street1"}
                    label={"Street1 *"}
                    value={this.state.details.billing.street1}
                    onChange={(e) => {
                      this.setBilling(e);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    inputClass={classes.inputClass}
                    name={"street2"}
                    placeholder={"Street2"}
                    label={"Street2"}
                    value={this.state.details.billing.street2}
                    onChange={(e) => {
                      this.setBilling(e);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    inputClass={classes.inputClass}
                    name={"city"}
                    placeholder={"City"}
                    label={"City *"}
                    value={this.state.details.billing.city}
                    onChange={(e) => {
                      this.setBilling(e);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    inputClass={classes.inputClass}
                    name={"zip"}
                    placeholder={"Postal Code"}
                    label={"Postal Code"}
                    value={this.state.details.billing.zip}
                    onChange={(e) => {
                      this.setBilling(e);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Select
                    onChange={(e) => {
                      this.setBilling(e);
                    }}
                    selectClass={classes.inputClass}
                    name={"country"}
                    label={"Country *"}
                    selected={this.state.details.billing.country}
                    options={stateCode.country}
                    default={"Select Country"}
                    value={(a) => a.abbreviation}
                    optionLabel={(a) => a.name}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Select
                    name={"state"}
                    placeholder={"State"}
                    label={"State *"}
                    onChange={(e) => {
                      this.setBilling(e);
                    }}
                    selectClass={classes.inputClass}
                    selected={this.state.details.billing.state}
                    options={
                      this.state.details.billing &&
                      this.state.details.billing.country
                        ? stateCode.state[this.state.details.billing.country]
                        : []
                    }
                    default={"Select State"}
                    value={(a) => a.abbreviation}
                    optionLabel={(a) => a.name}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <h3 className={classes.DetailssubTitle}>Shipping Address</h3>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={this.state.isSame}
                        onChange={(e) => {
                          this.setIsSame();
                        }}
                        name="sameCheck"
                      />
                    }
                    label="Use same as Billing Address"
                  />
                </Grid>
                {this.state.isSame ? null : (
                  <React.Fragment>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Input
                        inputClass={classes.inputClass}
                        name={"attention"}
                        placeholder={"Attention"}
                        label={"Attention *"}
                        value={this.state.details.shipping.attention}
                        onChange={(e) => {
                          this.setShipping(e);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <InputPhone
                        inputClass={classes.inputClass}
                        name={"phone"}
                        placeholder={"Phone"}
                        label={"Phone"}
                        value={this.state.details.shipping.phone}
                        onChange={(e) => {
                          this.setShipping(e);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Input
                        inputClass={classes.inputClass}
                        name={"street1"}
                        placeholder={"Street1"}
                        label={"Street1 *"}
                        value={this.state.details.shipping.street1}
                        onChange={(e) => {
                          this.setShipping(e);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Input
                        inputClass={classes.inputClass}
                        name={"street2"}
                        placeholder={"Street2"}
                        label={"Street2"}
                        value={this.state.details.shipping.street2}
                        onChange={(e) => {
                          this.setShipping(e);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Input
                        inputClass={classes.inputClass}
                        name={"city"}
                        placeholder={"City"}
                        label={"City *"}
                        value={this.state.details.shipping.city}
                        onChange={(e) => {
                          this.setShipping(e);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Input
                        inputClass={classes.inputClass}
                        name={"zip"}
                        placeholder={"Postal Code"}
                        label={"Postal Code"}
                        value={this.state.details.shipping.zip}
                        onChange={(e) => {
                          this.setShipping(e);
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Select
                        onChange={(e) => {
                          this.setShipping(e);
                        }}
                        selectClass={classes.inputClass}
                        name={"country"}
                        label={"Country *"}
                        selected={this.state.details.shipping.country}
                        options={stateCode.country}
                        default={"Select Country"}
                        value={(a) => a.abbreviation}
                        optionLabel={(a) => a.name}
                      />
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Select
                        name={"state"}
                        placeholder={"State"}
                        label={"State *"}
                        onChange={(e) => {
                          this.setShipping(e);
                        }}
                        selectClass={classes.inputClass}
                        selected={this.state.details.shipping.state}
                        options={
                          this.state.details.shipping &&
                          this.state.details.shipping.country
                            ? stateCode.state[
                                this.state.details.shipping.country
                              ]
                            : []
                        }
                        default={"Select State"}
                        value={(a) => a.abbreviation}
                        optionLabel={(a) => a.name}
                      />
                    </Grid>
                  </React.Fragment>
                )}
              </Grid>
            </React.Fragment>
            <br />
            <Button
              onClick={() => {
                this.update();
              }}
            >
              Update
            </Button>
          </>
        )}
        <Loader loading={this.state.loading} />
      </main>
    );
  }
}

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(withNavigation(UpdateOrderContact));
